export default __webpack_public_path__ + "static/media/shield0.5e88409c.svg";